import { useGetChatrooms } from '@pba/react-chat-core';
import { useEffect, useMemo } from 'react';
import type { ChatroomsSearchParamsOptions } from '../types';
import { ChatroomsSkeleton } from './chatrooms-skeleton';
import { EmptyMessages } from './empty-messages';

type P = {
  onCreateChatClicked: () => Promise<void>;
  redirectToChatroom: (chatroomId: string) => Promise<void>;
  searchParamsOptions: ChatroomsSearchParamsOptions;
};

const DefaultChatroom = ({ onCreateChatClicked, redirectToChatroom, searchParamsOptions }: P) => {
  const { data, isLoading } = useGetChatrooms({
    filter: {},
  });

  const firstChatroomId = useMemo(() => data?.pages.flat().find((chatroom) => chatroom !== null)?._id, [data]);

  useEffect(() => {
    if (firstChatroomId) {
      void redirectToChatroom(firstChatroomId);
    }
  }, [firstChatroomId, redirectToChatroom]);

  return isLoading || firstChatroomId ? (
    <ChatroomsSkeleton onCreateChatClicked={onCreateChatClicked} searchParamsOptions={searchParamsOptions} />
  ) : (
    <EmptyMessages onCreateChatClicked={onCreateChatClicked} />
  );
};

export default DefaultChatroom;
